import { createSelector } from '@ngrx/store';
import { TMachineMaintenanceState } from '../reducers';
import { TLineSetUpState } from './line-setup.models';

export const getLineSetupState = (state: TMachineMaintenanceState) => state.lineSetupInfo;

export const getProductionAreaWorkStations = createSelector(
  getLineSetupState,
  (state: TLineSetUpState) => state.productionAreaWorkStations,
);

export const getFactoryLineWorkstationSummaryList = createSelector(
  getLineSetupState,
  (state: TLineSetUpState) => state.factoryLineWorkstationSummaryList,
);

export const getFactoryLinesForShiftManagement = createSelector(
  getLineSetupState,
  (state: TLineSetUpState) => state.factoryLinesForShiftManagement,
);
